import { Fragment, useEffect, useState, useLayoutEffect } from 'react';
import ApplicationsApi from '../../services/applications'
import ApartmentsApi from '../../services/apartments'
import UsersApi from '../../services/users'
// import { BeforeLoginStepProps } from '../Apartment/BeforeLoginStepper/BeforeLoginStepper'
// import NextStepButton from '../Apartment/BeforeLoginStepper/NextStepButton';
// import { History } from 'history';
// import { AddShowingsFormData } from '../../types/showings';
// import { BaseFormStepProps } from '../../types/instant-rent';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles'
import {
    Box,
    Grid,
    Typography,
    CircularProgress,
    Checkbox,
    List,
    ListItem,
    ListItemIcon,
} from '@material-ui/core'
import Button from '@material-ui/core/Button';
import { paymentStyles } from '../../styles/paymentStyles'
import { apartmentStyles } from '../../styles/apartmentStyles'
import { Apartment, ApartmentStatus } from '../../types/apartments'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux';
import { navigate } from '../../actions/routes'
import './Payment.css';
import HotlineIcon from '../../images/paymentPage/hotline.svg'
import HouseSearchIcon from '../../images/paymentPage/houseSearch.svg'
import SigningContractIcon from '../../images/paymentPage/signingContract.svg'
//import ContractIcon from '../../images/paymentPage/contract.svg'
import ChatIcon from '../../images/paymentPage/chat.svg'
import ScheduleIcon from '../../images/paymentPage/schedule.svg'
//import Login from '../Authentication/Login/index';
import Suggest from '../Apartment/Stepper/Steps/Suggest'
import DigivakuusFaqLink from '../../components/Digivakuus/DigivakuusFaqLink'

const useStylesCombined = makeStyles((theme) => ({
    ...paymentStyles(theme),
    ...apartmentStyles(theme),
}));

const Payment = () => {
    const MOBILE_BREAKPOINT = 900
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const classes = useStylesCombined();
    const [paymentProviders, setPaymentProviders] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [isProductsLoading, setIsProductsLoading] = useState(false)
    //const [isInMarketing, setIsInMarketing] = useState(false);
    const [isInCreated, setIsInCreated] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [couponErrorMessage, setCouponErrorMessage] = useState<string | null>(null);
    const [couponSuccessMessage, setCouponSuccessMessage] = useState<string | null>(null);
    const [couponApplied, setCouponApplied] = useState(false);
    const [discountedVuokraoviPriceInCents, setDiscountedVuokraoviPriceInCents] = useState<number | null>(null);
    const [showPaymentMethods, setShowPaymentMethods] = useState(false);
    const { apartmentId, userId } = useParams<RouteParams>();
    // const [isChecked, setIsChecked] = useState(false);
    // const [showCheckboxError, setShowCheckboxError] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [totalPriceInCents, setTotalPriceInCents] = useState(0)
    const [products, setProducts] = useState([]);
    const [purchaseButtonDisabled, setPurchaseButtonDisabled] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT)
    const [showPremiumSelection, setShowPremiumSelection] = useState(false)
    const [hasVisitedPremiumSelection, setHasVisitedPremiumSelection] = useState(false)
    const [paymentFlowStarted, setPaymentFlowStarted] = useState(false)
    // const products = [
    //     { id: 1, name: "Leea", price: 0 },
    //     { id: 2, name: "Vuokraovi", price: 70 },
    //     { id: 3, name: "Oikotie", price: 70 },
    //     { id: 4, name: "FB/IG", price: 40 },
    // ];

    type RouteParams = {
        apartmentId: string;  // or number if you expect a number
        userId: string;       // same here
    };

    const premiumProducts = products.filter(product => product.tags?.includes('premiumProductBundle'))
    const baseProducts = products.filter(product => !product.tags?.includes('premiumProductBundle'))
    const premiumSelectionAvailable = premiumProducts.some(product => !product.productOwned)
    const shouldRenderPremiumStep = showPremiumSelection && premiumSelectionAvailable
    const canShowPremiumBundle = shouldRenderPremiumStep || (hasVisitedPremiumSelection && premiumSelectionAvailable)
    const visibleProducts = shouldRenderPremiumStep
        ? premiumProducts
        : canShowPremiumBundle
            ? [...baseProducts, ...premiumProducts]
            : baseProducts
    const suggestContentKey = shouldRenderPremiumStep ? 'paymentPage.premiumSuggestBoxContent' : 'paymentPage.suggestBoxContent'
    const suggestContent = t(suggestContentKey)
    const shouldShowSelectedProductsHeading = canShowPremiumBundle || paymentFlowStarted || showPaymentMethods
    const productSelectionHeadingKey = shouldRenderPremiumStep
        ? 'paymentPage.choosePremiumBundle'
        : shouldShowSelectedProductsHeading
            ? 'paymentPage.selectedProductsHeading'
            : 'paymentPage.chooseProducts'

    const renderFaqLink = () => (
        <DigivakuusFaqLink
            t={t}
            buttonClassName={classes.faqButton}
            contentKeys={
                shouldRenderPremiumStep
                    ? ['paymentPage.premiumSuggestFaqContent', 'apartments.rented.depositServiceInfo']
                    : undefined
            }
            titleKeys={
                shouldRenderPremiumStep
                    ? ['paymentPage.premiumSuggestFaqTitle', 'apartments.rented.depositServiceTitle']
                    : undefined
            }
            detailsSections={
                shouldRenderPremiumStep
                    ? [
                        {
                            key: 'premium-faq-detail-1',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle1',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer1'
                        },
                        {
                            key: 'premium-faq-detail-2',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle2',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer2'
                        },
                        {
                            key: 'premium-faq-detail-3',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle3',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer3'
                        },
                        {
                            key: 'premium-faq-detail-4',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle4',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer4'
                        }
                    ]
                    : undefined
            }
        />
    )

    const faqFooter = shouldRenderPremiumStep
        ? (
            <div className={classes.faqLinkWrapper}>
                {renderFaqLink()}
            </div>
        )
        : undefined

    const handleProceedToPremiumSelection = () => {
        if (premiumSelectionAvailable) {
            setShowPremiumSelection(true)
            setHasVisitedPremiumSelection(true)
            return
        }
        rentalPaymentHandler()
    }

    const handlePremiumContinue = () => {
        setShowPremiumSelection(false)
        rentalPaymentHandler()
    }

    const handleProductSelect = (productId) => {
        const product = products.find(p => p.productId === productId)

        if (product?.productOwned || product?.undeselectable) {
            return
        }

        let updatedSelection = []

        const isSelected = selectedProducts.includes(productId)
        if (isSelected) {
            updatedSelection = selectedProducts.filter(id => id !== productId)
        } else {
            if (productId === '8' || productId === '10') {
                updatedSelection = [
                    ...selectedProducts.filter(id => id !== '8' && id !== '10'),
                    productId
                ]
            } else {
                updatedSelection = [...selectedProducts, productId]
            }
        }

        const newTotalPrice = updatedSelection.reduce((total, id) => {
            const selectedProduct = products.find(p => p.productId === id)
            if (!selectedProduct?.productOwned || product?.undeselectable) {
                return selectedProduct ? total + selectedProduct.priceInEuros * 100 : total
            }
            return total
        }, 0)

        setSelectedProducts(updatedSelection)
        setTotalPriceInCents(newTotalPrice)

        const allOwned = updatedSelection.every(id => {
            const selectedProduct = products.find(p => p.productId === id);
            return selectedProduct?.productOwned;
        })

        setPurchaseButtonDisabled(allOwned)

        if (showPaymentMethods) {
            rentalPaymentHandler(newTotalPrice, updatedSelection)
        }
    }

    async function rentalPaymentHandler(newPrice?: number, nextSelectedProducts?: string[]) {
        try {
            setPurchaseButtonDisabled(true)
            setIsLoading(true)

            const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId)
            if (!apartment) return

            if (apartment.status == ApartmentStatus.created) {
                setIsInCreated(true)
                setIsLoading(false)
                return
            }

            const priceToUse = newPrice ?? totalPriceInCents
            const productsForPayment = nextSelectedProducts ?? selectedProducts

        if (priceToUse === 0) {
            await addRightsAndPublish(apartment, productsForPayment)
        } else {
            setPaymentFlowStarted(true)
            const apartmentCode = apartment.code
            const apartmentInfo = {
                userId,
                    apartmentId,
                    apartmentCode,
                    publishCostInCents: priceToUse,
                    selectedProducts: productsForPayment,
                    ...(couponApplied ? { couponCode } : {})
                }

                const paymentResponse = await ApplicationsApi.initiatePaymentForPublish(apartmentInfo)
                const filteredResponse = {
                    ...paymentResponse,
                    providers: paymentResponse.providers?.filter(method =>
                        method.id !== 'amex' &&
                        method.id !== 'apple-pay' &&
                        method.id !== 'nordea-business' &&
                        method.id !== 'siirto'
                    ) || []
                }
                setShowPremiumSelection(false)
                setShowPaymentMethods(true)
                setPaymentProviders(filteredResponse || null)
                setIsLoading(false)
            }
        } catch (error) {
            console.error(error)
        }
    }

    async function addRightsAndPublish(apartment: Apartment, rights: string[] = selectedProducts) {
        try {
            const response = await ApartmentsApi.addRights(apartment, rights);

            await ApartmentsApi.updateStatus(userId,
                apartmentId,
                { status: 'marketing' })
            //dispatch(navigate(`/apartments?status=ok`));
        } catch (error) {
            console.error('Error adding products:', error);
        }
    }

    const getProducts = async () => {
        setIsProductsLoading(true)
        try {
            const tags = ['platform', 'premiumProductBundle']
            const response = await ApartmentsApi.getProducts(tags)

            if (response && response.products) {
                const filteredProducts = response.products.filter(product =>
                    product.tags?.some(tag => ["platform", "premiumProductBundle"].includes(tag))
                );

                const sortedProducts = filteredProducts
                    .map(product => ({
                        ...product,
                        //productOwned: product.name === "Leea"
                        undeselectable: product.productId == "2"
                    }))
                    .sort((a, b) => {
                        const priorityOrder = ["2", "8"]
                        const aIndex = priorityOrder.indexOf(a.productId)
                        const bIndex = priorityOrder.indexOf(b.productId)

                        if (aIndex === -1 && bIndex === -1) {
                            return a.name.localeCompare(b.name)
                        }
                        if (aIndex === -1) return 1
                        if (bIndex === -1) return -1
                        return aIndex - bIndex
                    })

                setProducts(sortedProducts)

                const leeaProductIds = sortedProducts
                    .filter(product => product.undeselectable)
                    .map(product => product.productId)

                setSelectedProducts(prevSelected => [...new Set([...prevSelected, ...leeaProductIds])])

                const vuokraoviProduct = sortedProducts.find(p => p.productId == "2")
                if (vuokraoviProduct && !vuokraoviProduct.productOwned) {
                    const priceInCents = Math.round(Number(vuokraoviProduct.priceInEuros) * 100)
                    setTotalPriceInCents(priceInCents)
                }

                await paymentPageHandler(sortedProducts)
            }
        } catch (error) {
            console.error('Error fetching products:', error)
        }
        setIsProductsLoading(false)
    }

    useEffect(() => {
        getProducts();
        //paymentPageHandler();
    }, []);

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    async function paymentPageHandler(sortedProducts) {
        try {
            // You may want to start a loading state here
            // setLoading(true);
            //setIsLoading(true);

            // Fetch the apartment data
            const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId);
            if (!apartment) {
                // Handle error appropriately here
                return; // You can return here if you don't want to proceed further in case of an error
            }

            // if (apartment.status == ApartmentStatus.marketing) {
            //     setIsLoading(false);
            //     return;
            // }

            if (apartment.status == ApartmentStatus.created) {
                setIsInCreated(true);
                setIsLoading(false);
                return;
            }

            const rightsProductIds = (apartment.rights || []).filter(rightId =>
                sortedProducts.some(product => product.productId === rightId && (product.tags?.includes("platform") || product.tags?.includes("premiumProductBundle")))
            );

            setPurchaseButtonDisabled(rightsProductIds.length > 0);

            setSelectedProducts(prevSelected => {
                const updatedSelection = [...new Set([...prevSelected, ...rightsProductIds])]
                return updatedSelection
            })

            setProducts(prevProducts => {
                const updatedProducts = prevProducts.map(product => {
                    const isproductOwned = rightsProductIds.includes(String(product.productId)) || product.productOwned
                    return {
                        ...product,
                        productOwned: isproductOwned
                    }
                })
                return updatedProducts
            })
            //setIsLoading(false);
        } catch (error) {
        }
    }

    async function handleCoupon(couponCode: string) {
        // Reset messages when attempting again
        setIsLoading(true);
        setCouponErrorMessage(null);
        setCouponSuccessMessage(null);
        setDiscountedVuokraoviPriceInCents(null);

        if (couponCode.length < 4) {
            setCouponErrorMessage(t('paymentPage.couponCodeTooShort'));
            setIsLoading(false);
            return;
        }

        try {
            const couponResponse = await ApplicationsApi.handlePaymentCoupon(couponCode, userId, 'platform');

            if (couponResponse && couponResponse.status === 'valid') {
                const discountInCents = couponResponse.discountInCents
                const discountPercentage = couponResponse.discountPercentage
                const isAle2025 = couponCode.trim().toLowerCase() === 'ale2025'

                let newPrice = totalPriceInCents

                if (isAle2025) {
                    const vuokraoviProduct = products.find(p => p.productId === '2')
                    const vuokraoviPriceInCents = vuokraoviProduct ? Math.round(Number(vuokraoviProduct.priceInEuros || 0) * 100) : 0
                    const discountBase = Math.min(vuokraoviPriceInCents, totalPriceInCents)

                    let discountAmount = 0
                    if (discountInCents !== undefined && discountInCents !== null) {
                        discountAmount = Math.min(discountInCents, discountBase)
                    } else if (discountPercentage !== undefined && discountPercentage !== null) {
                        discountAmount = Math.round(discountBase * (discountPercentage / 100))
                    }

                    const discountedVuokraoviPrice = Math.max(0, discountBase - discountAmount)
                    const otherProductsTotal = Math.max(0, totalPriceInCents - discountBase)
                    newPrice = Math.max(0, otherProductsTotal + discountedVuokraoviPrice)

                    setDiscountedVuokraoviPriceInCents(discountedVuokraoviPrice)
                } else if (discountInCents !== undefined && discountInCents !== null) {
                    newPrice = Math.max(0, totalPriceInCents - discountInCents)
                } else if (discountPercentage !== undefined && discountPercentage !== null) {
                    const discount = discountPercentage / 100
                    newPrice = Math.max(0, totalPriceInCents * (1 - discount))
                }

                setCouponApplied(true);
                setTotalPriceInCents(newPrice);
                setCouponSuccessMessage(t('paymentPage.couponAppliedSuccessfully')); // New message for successful coupon application

                if (newPrice <= 0) {
                    setShowPaymentMethods(false);
                } else {
                    setShowPaymentMethods(true);
                    await rentalPaymentHandler(newPrice);  // Reinitialize the payment methods with the new price
                }


            } else if (couponResponse && couponResponse.status === 'failed') {
                if (couponResponse.message === 'Coupon not found') {
                    setCouponErrorMessage(t('paymentPage.couponNotFound'));
                } else if (couponResponse.message === 'Wrong use case') {
                    setCouponErrorMessage(t('paymentPage.couponWrongUseCase'));
                } else if (couponResponse.message === 'Coupon has expired') {
                    setCouponErrorMessage(t('paymentPage.couponExpired'));
                } else if (couponResponse.message === 'Coupon already used') {
                    setCouponErrorMessage(t('paymentPage.couponAlreadyUsed'));
                } else {
                    // Handle other unexpected messages
                    setCouponErrorMessage(t('paymentPage.couponNotFound'));
                }
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    const formatPriceDisplay = (priceInEuros: number, freeText: string) => {
        if (priceInEuros === 0) return freeText
        if (priceInEuros % 1 === 0) return `${priceInEuros},00 €`
        return priceInEuros.toFixed(2).replace('.', ',') + ' €'
    }

    const renderProductPrice = (product: any) => {
        const isVuokraovi = product.productId === '2'
        const hasVuokraoviDiscount = couponApplied && discountedVuokraoviPriceInCents !== null && isVuokraovi
        const discountedPriceEuros = hasVuokraoviDiscount && discountedVuokraoviPriceInCents !== null
            ? discountedVuokraoviPriceInCents / 100
            : null

        if (product.productOwned) {
            return (
                <Box
                    style={{
                        width: "81px",
                        height: "32px",
                        background: "#94004A",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography
                        style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            color: "#FFFFFF",
                            textAlign: "center",
                        }}
                    >
                        {t('paymentPage.productOwned')}
                    </Typography>
                </Box>
            )
        }

        if (hasVuokraoviDiscount) {
            return (
                <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Box
                        style={{
                            minWidth: "81px",
                            height: "32px",
                            background: "#CBD4DA",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#374151",
                                textDecoration: 'line-through',
                            }}
                        >
                            {formatPriceDisplay(product.priceInEuros, t('paymentPage.freeOfCharge'))}
                        </Typography>
                    </Box>
                    <Box
                        style={{
                            minWidth: "81px",
                            height: "32px",
                            background: "#94004A",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "16px",
                                fontWeight: "700",
                                color: "#FFFFFF",
                                textAlign: "center",
                            }}
                        >
                            {formatPriceDisplay(discountedPriceEuros ?? 0, t('paymentPage.freeOfCharge'))}
                        </Typography>
                    </Box>
                </Box>
            )
        }

        return (
            <Box
                style={{
                    width: "81px",
                    height: "32px",
                    background: "#94004A",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                        textAlign: "center",
                    }}
                >
                    {formatPriceDisplay(product.priceInEuros, t('paymentPage.freeOfCharge'))}
                </Typography>
            </Box>
        )
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])
    async function plainPublishFunction() {
        // Reset messages when attempting again        
        // if (!isChecked) {
        //     setShowCheckboxError(true); // Show error if button is clicked without checking
        // } else {
        setIsLoading(true);
        //setShowCheckboxError(false);
        try {
            const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId)

            await addRightsAndPublish(apartment)

            //dispatch(navigate(`/apartments?status=ok`));

            const coupons: { couponCode: string } = {
                couponCode
            };
            try {
                const response = await UsersApi.updateUserUsedCoupons(userId, coupons)
                dispatch(navigate(`/apartments?status=ok`));
            } catch (error) {
                console.error(error);
            }

        } catch (error) {
            console.error(error)
        }
        setIsLoading(false);
        //}
    }

    return (
        <Fragment>
            <div className="container">
                <div className="column column1">
                    {isMobile && !showPaymentMethods && !isLoading && (
                        <Suggest
                            content={suggestContent}
                            containerMaxWidth='100%'
                            contentMaxWidth='100%'
                            padding='0px'
                            suggestContainerPadding='25px 10px'
                            footerContent={faqFooter}
                        />
                    )}
                    <h2 className="main-header">{t('paymentPage.disclaimerPageHeader')}</h2>
                    <div className="textitem">
                        <img src={SigningContractIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer1Header')}.</strong> {t('paymentPage.disclaimer1Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={ChatIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer2Header')}.</strong> {t('paymentPage.disclaimer2Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={ScheduleIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer3Header')}.</strong> {t('paymentPage.disclaimer3Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={HouseSearchIcon} alt="Apartment Building" />
                        <div className="adjust-text">
                            <p><strong>{t('paymentPage.disclaimer4Header')}.</strong> {t('paymentPage.disclaimer4Text')}.</p>
                        </div>
                    </div>
                    <div className="textitem">
                        <img src={HotlineIcon} alt="Apartment Building" />
                        <div style={{ marginLeft: '4px' }}>
                            <p><strong>{t('paymentPage.disclaimer5Header')}.</strong> {t('paymentPage.disclaimer5Text')}.</p>
                        </div>
                    </div>
                    {/* Repeat for the remaining items */}
                </div>
                <div className="column column2">
                    <Grid container direction='row' justify='space-evenly'>
                        <Grid container>
                            <Grid item xs={12}>
                                {/* <Typography
                                variant='h4'
                                className={`${classes.centeredText} ${classes.heading
                                    } ${isMobile ? classes.my6 : classes.my8}`}
                            > */}

                                {(!isInCreated) ? (
                                    !isProductsLoading) ? (
                                    <>
                                        <h2 className="additionalMarginTopMd"> {t(productSelectionHeadingKey)}</h2>
                                        <List>
                                            {visibleProducts.map((product) => (
                                                <div key={product.productId} style={{
                                                    width: "90% !important",
                                                    maxWidth: "90% !important",
                                                    marginRight: "20px",
                                                    marginLeft: "20px"
                                                }}>
                                                    <ListItem
                                                        key={product.productId}
                                                        divider
                                                        onClick={() => handleProductSelect(product.productId)}
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "row",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            padding: "12px",
                                                            width: "100%", // Ensures ListItem takes full width of the parent div
                                                            height: "56px",
                                                            background: "#F7F8F9",
                                                            borderRadius: "12px",
                                                            cursor: product.productOwned || product?.undeselectable ? "default" : "pointer",
                                                            margin: "8px 0px", // Adjust spacing between items
                                                            boxSizing: "border-box",
                                                            backgroundColor: selectedProducts.includes(product.productId) ? "#FCF3F5" : "#F7F8F9", // Conditional background color
                                                        }}
                                                    >
                                                        <Box
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                gap: "12px",
                                                            }}
                                                        >
                                                            <ListItemIcon style={{ minWidth: "30px" }}>
                                                                <Checkbox
                                                                    //disabled={product.productOwned == true}
                                                                    className="checkbox"
                                                                    checked={selectedProducts.includes(product.productId)}
                                                                    //onChange={() => handleProductSelect(product.productId)}
                                                                    style={{
                                                                        transform: "scale(1.2)",
                                                                        color: selectedProducts.includes(product.productId) ? "#94004A" : "#CBD4DA",
                                                                    }}
                                                                    color="primary"
                                                                />
                                                            </ListItemIcon>
                                                            <Typography
                                                                style={{
                                                                    fontSize: "14px",
                                                                    fontWeight: "450",
                                                                    color: "#2F2F2F",
                                                                }}
                                                            >
                                                                {product.name}
                                                            </Typography>
                                                        </Box>
                                                        <Box
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "flex-end",
                                                                gap: "8px",
                                                                minWidth: "81px",
                                                            }}
                                                        >
                                                            {renderProductPrice(product)}
                                                        </Box>
                                                    </ListItem>
                                                </div>
                                            ))}
                                        </List>
                                        {!purchaseButtonDisabled && (
                                            <div style={{
                                                marginTop: '0.5rem',
                                                marginBottom: isMobile ? '2.5rem' : '0.2rem',
                                                marginLeft: '20px',
                                                marginRight: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '0.5rem'
                                            }} className={`${classes.centeredText}`} >
                                                <Button
                                                    onClick={shouldRenderPremiumStep ? handlePremiumContinue : handleProceedToPremiumSelection}
                                                    variant="contained"
                                                    color="primary"
                                                    className={`${classes.centeredText}`}
                                                    style={{ width: '100%', height: '3.5rem' }}
                                                >
                                                    {shouldRenderPremiumStep ? t('paymentPage.confirmPurchase') : t('paymentPage.next')}
                                                </Button>
                                            </div>
                                        )}
                                        {!showPaymentMethods && !isLoading && !isMobile && (
                                            <Grid item xs={12}>
                                                <Grid container justifyContent="center">
                                                    <Grid item xs={12} sm={6}>
                                                        <Suggest
                                                            content={suggestContent}
                                                            containerMaxWidth='100%'
                                                            contentMaxWidth='100%'
                                                            footerContent={faqFooter}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </>
                                ) : (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%'
                                    }}>
                                        <CircularProgress
                                            size={72}
                                            style={{ color: '#94004A', margin: '25px' }}
                                        />
                                    </div>
                                ) : null}
                            </Grid>
                            {!isLoading ? (
                                !isInCreated ? (
                                    showPaymentMethods ? (
                                        <div>
                                            <div >
                                                {/* <Typography
                                            variant='h4'
                                            className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                        >
                                            {t('paymentPage.choosePaymentMethod')}
                                        </Typography> */}
                                                <h2 className="additionalMarginTopMd"> {t('paymentPage.choosePaymentMethod')}</h2>
                                                {/* <h2 className="additionalMarginTopMd"> {t('paymentPage.paymentTerms')}</h2> */}
                                            </div>
                                            {paymentProviders !== undefined && paymentProviders ? (
                                                <>
                                                    {/* <Typography
                                                        variant='h5'
                                                        className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                                        style={{ marginBottom: '10px' }}
                                                    >
                                                        {t('paymentPage.choosePaymentMethod')}
                                                    </Typography> */}
                                                    <div className={classes.paymentOption}>
                                                        {paymentProviders.providers.map((provider: any) => (
                                                            <form
                                                                method='POST'
                                                                action={provider.url}
                                                                key={provider.id}
                                                                className={classes.paymentCard}
                                                                onSubmit={(event) => {
                                                                    event.preventDefault()
                                                                    event.currentTarget.submit()
                                                                }}
                                                            >
                                                                {provider.parameters.map(
                                                                    (param: {
                                                                        name: string | undefined
                                                                        value:
                                                                        | string
                                                                        | number
                                                                        | readonly string[]
                                                                        | undefined
                                                                    }) => (
                                                                        <input
                                                                            key={param.name}
                                                                            type='hidden'
                                                                            name={param.name}
                                                                            value={param.value}
                                                                        />
                                                                    )
                                                                )}
                                                                <button className="paymentProvider">
                                                                    <img
                                                                        style={{
                                                                            objectFit: 'contain',
                                                                            width: '80%',
                                                                        }}
                                                                        src={provider.svg}
                                                                        alt={provider.value}
                                                                    />
                                                                </button>
                                                            </form>
                                                        ))}
                                                    </div>
                                                    <Grid container spacing={2} alignItems="center" className="gridContainer">
                                                        <Grid item xs={12} md={12}>
                                                            {!couponApplied && (
                                                                <form
                                                                    className={`couponForm`}
                                                                    onSubmit={(event) => {
                                                                        event.preventDefault();
                                                                        // Handle coupon validation here.
                                                                        handleCoupon(couponCode);
                                                                    }}
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder={t('paymentPage.insertCouponCode')}
                                                                        onChange={(e) => {
                                                                            setCouponCode(e.target.value);
                                                                        }}
                                                                        className={`couponInput`}
                                                                        style={{
                                                                            // width: 'calc(100% - 170px)',

                                                                        }}
                                                                    />
                                                                    <Button type="submit" variant="contained" color="primary" className={`couponButton`}
                                                                        style={{
                                                                            height: '3.05rem',
                                                                            paddingLeft: '25px',
                                                                            paddingRight: '25px',
                                                                        }}>
                                                                        {t('paymentPage.applyCoupon')}
                                                                    </Button>
                                                                </form>
                                                            )}
                                                            {couponErrorMessage && (
                                                                <Typography
                                                                    variant='body1'
                                                                    className={`couponForm errorText couponMessage`}
                                                                >
                                                                    {couponErrorMessage}
                                                                </Typography>
                                                            )}
                                                            {couponSuccessMessage && (
                                                                <Typography
                                                                    variant='body1'
                                                                    className={`couponForm successText couponMessage`}
                                                                >
                                                                    {couponSuccessMessage}
                                                                </Typography>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                    {/* End of coupon form */}
                                                    <Typography
                                                        variant='body1'
                                                        className="paymentTermsDisclaimer"
                                                    >
                                                        <pre className='MuiTypography-root MuiTypography-body1'>
                                                            {t('paymentPage.paymentTermsDisclaimerTextPart')}{' '}
                                                            <a
                                                                style={{ color: '#94004A', textDecoration: 'none', fontWeight: 'bold' }}
                                                                href='https://www.leea.fi/kayttoehdot'
                                                                target='_blank'
                                                                rel='noreferrer'
                                                            >
                                                                {t('paymentPage.paymentTermsDisclaimerLinkPart')}
                                                            </a>
                                                        </pre>
                                                    </Typography>
                                                </>
                                            ) : (
                                                <Grid item xs={12}>
                                                    {/* <Typography
                                        variant='h5'
                                        className={`${classes.centeredText} ${classes.heading
                                            } ${isMobile ? classes.my6 : classes.my8}`}
                                    >
                                        {t('general.notAvailable')}
                                    </Typography> */}
                                                    <Typography
                                                        variant='h5'
                                                        className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                                    >
                                                        {t('paymentPage.paymentProvidersNotFound')}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </div>
                                    ) : (
                                        couponApplied && totalPriceInCents === 0 && (
                                            <>
                                                <div style={{ width: '100%' }} className={`${classes.centeredText} ${classes.my6}`}>
                                                    {couponSuccessMessage && (
                                                        <Typography
                                                            variant='body1'
                                                            className={`${classes.centeredText} ${classes.my6}`}
                                                            style={{ color: 'green', width: '100%', marginTop: '5px' }}
                                                        >
                                                            {couponSuccessMessage}
                                                        </Typography>
                                                    )}

                                                    <Button
                                                        onClick={() => plainPublishFunction()}
                                                        variant="contained"
                                                        color="primary"
                                                        className={`${classes.centeredText}`}
                                                    >
                                                        {t('paymentPage.publish')}
                                                    </Button>
                                                </div>
                                            </>
                                        )
                                    )
                                ) : (
                                    <Typography
                                        variant='h4'
                                        className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                        style={{ marginBottom: '10px', width: '100%' }}
                                    >
                                        {t('paymentPage.isUnfinished')}
                                    </Typography>
                                )) : (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%'
                                }}>
                                    <CircularProgress
                                        size={72}
                                        style={{ color: '#94004A', margin: '25px' }}
                                    />
                                </div>
                            )}
                        </Grid>
                        {/* <Grid container className={classes.buttonContainer}>
                        <NextStepButton
                            type='button'
                            beforeLogin={beforeLogin}
                            setIsEmpty={setIsEmpty}
                            toValidate={{
                                buildingType: buildingInfo.buildingType
                            }}
                        />
                    </Grid> */}
                    </Grid>
                </div>
            </div>
        </Fragment >
    );
};

//export default withTranslation(Payment as any)
export default Payment
